
import React, {Component} from 'react'
import {autoCompleteEmoji} from '../../utils/draftjs/completeEntity'
import getDraftCoords from '../../utils/getDraftCoords'
import EmojiMenuContainer from './EmojiMenuContainer'
import getAnchorLocation from './getAnchorLocation'
import getWordAt from './getWordAt'

const withEmojis = (ComposedComponent) => {
  class WithEmojis extends Component {constructor(...args) { super(...args); WithEmojis.prototype.__init.call(this);WithEmojis.prototype.__init2.call(this);WithEmojis.prototype.__init3.call(this);WithEmojis.prototype.__init4.call(this);WithEmojis.prototype.__init5.call(this);WithEmojis.prototype.__init6.call(this);WithEmojis.prototype.__init7.call(this);WithEmojis.prototype.__init8.call(this); }
    

    __init() {this.state = {
      focusedEditorState: null,
      isOpen: false,
      query: ''
    }}

    __init2() {this.keyBindingFn = (e) => {
      const {keyBindingFn} = this.props
      if (keyBindingFn) {
        const result = keyBindingFn(e)
        if (result) return result
      }
      if (this.menuRef.current) {
        const handled = this.menuRef.current.handleKeyDown(e)
        if (handled) return handled
      }
      return undefined
    }}

    __init3() {this.menuRef = React.createRef()}

    static getDerivedStateFromProps(nextProps, prevState) {
      const {editorState} = nextProps
      return {
        // clicking on a menu will cause the editorStateSelection to lose focus, so we persist the last state before that point
        focusedEditorState: editorState.getSelection().getHasFocus()
          ? editorState
          : prevState.focusedEditorState
      }
    }

    __init4() {this.onSelectEmoji = (emoji) => {
      const {setEditorState} = this.props
      const nextEditorState = autoCompleteEmoji(
        this.state.focusedEditorState ,
        emoji
      )
      setEditorState(nextEditorState)
    }}

    __init5() {this.removeModal = () => {
      this.setState({
        isOpen: false,
        query: ''
      })
    }}

    __init6() {this.handleChange = (editorState) => {
      const {handleChange} = this.props
      if (handleChange) {
        handleChange(editorState)
      }
      const {block, anchorOffset} = getAnchorLocation(editorState)
      const blockText = block.getText()
      const entityKey = block.getEntityAt(anchorOffset - 1)
      const {word} = getWordAt(blockText, anchorOffset - 1)

      const inASuggestion = word && !entityKey && word[0] === ':'
      if (inASuggestion) {
        this.setState({
          isOpen: true,
          query: word.slice(1)
        })
      } else if (this.state.isOpen) {
        this.removeModal()
      }
    }}

    __init7() {this.initialize = () => {
      const {isOpen} = this.state
      if (isOpen) {
        const {renderModal, removeModal, keyBindingFn} = this
        return {renderModal, removeModal, keyBindingFn}
      }
      return {}
    }}

    __init8() {this.renderModal = () => {
      const {query} = this.state
      this.cachedCoords = getDraftCoords() || this.cachedCoords
      return (
        React.createElement(EmojiMenuContainer, {
          removeModal: this.removeModal,
          onSelectEmoji: this.onSelectEmoji,
          query: query,
          menuRef: this.menuRef,
          originCoords: this.cachedCoords,}
        )
      )
    }}

    render() {
      return (
        React.createElement(ComposedComponent, {
          ...this.props,
          ...this.initialize(),
          handleChange: this.handleChange,}
        )
      )
    }
  }
  return WithEmojis 
}

export default withEmojis
